import React from 'react'
import { Link } from 'react-router-dom'

const Navigation = () => {
  return (
    <div class=''>
        <nav class="navbar navi navbar-dark text-white navbar-expand-lg">
            <Link class='text-decoration-none' to={'/'}>
                <img src='./Images/logo1.jpeg' alt='' height={100} width={100} class='rounded'/>
            </Link>
            <Link class='text-decoration-none ' to={'/'}>
                <a class="navbar-brand nav-link ms-2" href="# ">Rj Engineering</a>
            </Link>
            <button type="button" class="navbar-toggler text-dark" data-bs-toggle="collapse" data-bs-target="#ull">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="ull">
                <ul class="navbar-nav ms-auto">
                    <Link class='text-decoration-none' to={'/'}>
                       <li class="nav-item ms-1 me-5"><a class="nav-link " href="#home">Home</a></li>
                    </Link>
                    <Link class='text-decoration-none ' to={'/About'}>
                       <li class="nav-item ms-1 me-5"><a class="nav-link " href="#about">About</a></li>
                    </Link>
                     <div class="btn-group">
                            <button type="button" class="btn  nav-b dropdown-toggle  me-5" data-bs-toggle="dropdown" aria-expanded="false">
                            Services
                            </button>
                            <ul class="dropdown-menu wid ">
                            <Link class='text-decoration-none' to={'/Annual'}>
                            <li><a class="dropdown-item" href="#">Annual Maintenance Works</a></li>
                            </Link>
                            <li><hr class="dropdown-divider wid1"/></li>
                            <Link class='text-decoration-none' to={'/Hydrant'}>
                            <li><a class="dropdown-item" href="#">Fire Hydrant Works</a></li>
                            </Link>
                            <li><hr class="dropdown-divider wid1"/></li>
                            <Link class='text-decoration-none' to={'/Fire'}>
                            <li><a class="dropdown-item" href="#">Fire Alarm & Security System Works</a></li>
                            </Link>
                            <li><hr class="dropdown-divider wid1"/></li>
                            <Link class='text-decoration-none' to={'/Plumbing'}>
                            <li><a class="dropdown-item" href="#">Plumbing Works</a></li>
                            </Link>
                            <li><hr class="dropdown-divider wid1"/></li>
                            <Link class='text-decoration-none' to={'/Hvac'}>
                            <li><a class="dropdown-item" href="#">HVAC Works</a></li>
                            </Link>
                            <li><hr class="dropdown-divider wid1"/></li>
                            <Link class='text-decoration-none' to={'/Electrical'}>
                            <li><a class="dropdown-item" href="#">Electrical Works</a></li>
                            </Link>        
                          </ul>
                       </div>
                    <Link class='text-decoration-none' to={'/Projects'}>
                       <li class="nav-item ms-1 me-5"><a class="nav-link " href="#project">Projects</a></li>
                    </Link>
                    <Link class='text-decoration-none' to={'/Gallery'}>
                       <li class="nav-item ms-1 me-5"><a class="nav-link text-warning" href="gallery">Gallery</a></li>
                    </Link>
                    <Link class='text-decoration-none' to={'/Contact'}>
                       <li class="nav-item ms-1 me-5"><a class="nav-link " href="#contact">Contact</a></li>
                    </Link>

                </ul>
            </div>
        </nav>
       
    </div>
  )
}

export default Navigation